import React, { Component } from 'react';
import styles from './Posts.module.css';
import axios from 'axios';
import {connect} from 'react-redux';
import loader from '../../assets/loader2.svg';
import PictureFrame from '../Modal/PictureFrame/PictureFrame';

class Posts extends Component {

    state = {
        users: {},
        user:{},
        posts: [],
        loading: true,
        pictureFrame: {
            isModalOpen: false,
            post:{}
        }
    }

    componentDidMount() {
        if(localStorage.getItem('explore_posts')) {
            const posts = JSON.parse(localStorage.getItem('explore_posts'));
            const users =JSON.parse(localStorage.getItem('explore_users'));
            this.setState({users: users, posts: posts});

        }
        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            const posts = [];
            Object.keys(response.data).map(userId => {
                if(userId !== this.props.loginStatus.userId && !response.data[userId].isAccountPrivate 
                    && response.data[userId].account_status !== 'DISABLED') {
                    const postArray = response.data[userId].posts.slice(1);
                    postArray.map((obj, index) => {
                        obj.userId = userId;
                        obj.index = index + 1;
                    })
                    posts.push(...postArray);
                }
               
            })
            posts.sort(this.sort);
            this.setState({users: response.data, posts: posts});
            localStorage.setItem('explore_posts',JSON.stringify(posts));
            localStorage.setItem('explore_users',JSON.stringify(response.data));
            
        })
    }

    togglePictureFrame = (event) => {
        const index = +event.target.id;
        const modal = {...this.state.pictureFrame};
        modal.isModalOpen = !this.state.pictureFrame.isModalOpen;
        modal.post = {...this.state.posts[index]};
        if(event.target.id) {
            modal.post.userId = modal.post.userId;
            modal.post.index = modal.post.index;
            modal.post.postIndex = index;
        }
       
        this.setState({pictureFrame: modal, user: this.state.users[modal.post.userId]});
    }

    onResponseHandler = (postObj) => {
        const posts = [...this.state.posts];
        postObj.index ++;
        posts.splice(postObj.postIndex, 1, postObj);
        this.setState({posts: posts});
    }

    getPosts = () => {
        const posts = this.state.posts;
        if(posts.length === 0) return;
        const row = [];
        let index = posts.length - 1;
        for(let i = 0; i< Math.ceil(posts.length / 3); i++) {
            const column = [];
            for(let j = 0; j < 3; j++) {
                if(index === -1) break;
                column.push(
                    <div key={index} className={styles.column}>
                        <img src={posts[index].url} alt="post" />
                        <div className={styles.cover} id={index} onClick={this.togglePictureFrame}></div>
                    </div>
                )
                index --;
            }
        row.push(<div key={i} className={styles.row}>{column}</div>);
        }
        if(this.state.loading) {
            this.setState({loading: false});
        }

        return row;
    }

    sort = (el1, el2) => {
        return new Date(el1.timestamp) < new Date(el2.timestamp) ? -1 : 1;
    }

    render() {
        return(
            <div className={styles.main}>
                <div className={styles.posts}>
                    {this.state.loading?
                    <div style={{marginTop:'25%'}}>
                        <img src={loader} alt="loading" width="40"/>
                        </div>:null
                    }
                    {
                        this.getPosts()
                    }
                </div>
                {this.state.pictureFrame.isModalOpen ? 
                <PictureFrame {...this.state.pictureFrame.post} user={this.state.user} 
                users={this.state.users} close={this.togglePictureFrame} onResponse={this.onResponseHandler}/> : null
                }
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus,
        userData: state.userData
    }
}

export default connect(mapStateToProps)(Posts);